import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

// Écran de transition OAuth Google: échange le session_id (fragment) contre notre session, puis redirige.
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = (location.hash || '').match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }
      const result = await loginWithGoogleSession(sessionId);
      // Nettoyer le fragment de l'URL
      window.history.replaceState(null, '', window.location.pathname);
      if (result.success) {
        toast.success('Connexion Google réussie !');
        navigate('/dashboard', { replace: true });
      } else {
        toast.error(result.error || 'Échec de la connexion Google');
        navigate('/login', { replace: true });
      }
    };
    run();
  }, [location.hash, loginWithGoogleSession, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-slate-950 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-14 w-14 border-t-2 border-b-2 border-blue-500 border-t-transparent mx-auto mb-4"></div>
        <p className="text-slate-400 text-sm">Connexion en cours…</p>
      </div>
    </div>
  );
};
